import React, { useMemo } from 'react';
import { downloadSvg } from '../utils/meshSvg';

type MeshStatus = 'idle' | 'vectorizing' | 'triangulating' | 'done' | 'error';

interface Props {
  templateDataUrl:  string;
  templateWidthMm:  number;
  templateHeightMm: number;
  meshSvg:          string | null;
  meshStatus:       MeshStatus;
  meshError:        string | null;
  onClose:          () => void;
}

const PANEL = 300;

const STATUS_LABEL: Record<MeshStatus, string> = {
  idle:          'Waiting…',
  vectorizing:   'Vectorizing contours…',
  triangulating: 'Triangulating mesh…',
  done:          'Mesh ready — click to download SVG',
  error:         'Error',
};

const TemplatePreviewDialog: React.FC<Props> = ({
  templateDataUrl, templateWidthMm, templateHeightMm,
  meshSvg, meshStatus, meshError, onClose,
}) => {
  const aspect = templateWidthMm / templateHeightMm;
  const tplW = aspect >= 1 ? PANEL : Math.round(PANEL * aspect);
  const tplH = aspect >= 1 ? Math.round(PANEL / aspect) : PANEL;

  const meshDataUrl = useMemo(() =>
    meshSvg
      ? `data:image/svg+xml;charset=utf-8,${encodeURIComponent(meshSvg)}`
      : null,
  [meshSvg]);

  const handleMeshClick = () => {
    if (meshSvg) downloadSvg('mesh_triangulation.svg', meshSvg);
  };

  const isWorking = meshStatus === 'vectorizing' || meshStatus === 'triangulating';

  return (
    <div className="tplprev-overlay" onClick={onClose}>
      <div className="tplprev-dialog" onClick={e => e.stopPropagation()}>

        <div className="tplprev-panels">

          {/* ── Lewa: miniatura szablonu ── */}
          <div className="tplprev-panel">
            <div className="tplprev-label">Template</div>
            <div className="tplprev-img-wrap" style={{ width: tplW, height: tplH }}>
              <img src={templateDataUrl} alt="template" style={{ width: tplW, height: tplH }} />
            </div>
            <div className="tplprev-sublabel">
              {templateWidthMm.toFixed(1)}&nbsp;×&nbsp;{templateHeightMm.toFixed(1)}&nbsp;mm
            </div>
          </div>

          {/* ── Prawa: wizualizacja siatki ── */}
          <div className="tplprev-panel">
            <div className={`tplprev-label${meshStatus === 'error' ? ' tplprev-label-error' : ''}`}>
              {STATUS_LABEL[meshStatus]}
            </div>
            <div
              className={`tplprev-img-wrap${meshSvg ? ' tplprev-clickable' : ''}`}
              style={{ width: PANEL, height: PANEL }}
              onClick={handleMeshClick}
              title={meshSvg ? 'Click to download mesh_triangulation.svg' : undefined}
            >
              {meshDataUrl
                ? <img src={meshDataUrl} alt="mesh" style={{ width: PANEL, height: PANEL }} />
                : (
                  <div className="tplprev-status-box">
                    {isWorking && <div className="tplprev-spinner" />}
                    <div className={`tplprev-status-text${meshStatus === 'error' ? ' tplprev-status-error' : ''}`}>
                      {meshStatus === 'error'
                        ? (meshError ?? 'Unknown error')
                        : STATUS_LABEL[meshStatus]
                      }
                    </div>
                  </div>
                )
              }
            </div>
          </div>

        </div>

        <div className="tplprev-footer">
          <button onClick={onClose}>Close</button>
        </div>

      </div>
    </div>
  );
};

export default TemplatePreviewDialog;
